module.exports = __webpack_public_path__ + "static/media/Jaime.408ce943.jpg";